import React, { cloneElement } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, HeartIcon, UsersIcon, ZapIcon, StarIcon } from 'lucide-react';
import { SEO } from '../components/SEO';
export const OverOnsPage = () => {
  return <main className="bg-[#0a0a0a]" data-id="element-1549">
      <SEO title="Over Ons | BKCustoms Car Styling Almere" description="Ontdek het verhaal achter BKCustoms in Almere. Gedreven door passie voor auto's en persoonlijke service, transformeren we voertuigen sinds 2020." data-id="element-1550" />
      {/* Hero Section - More Personal Approach */}
      <section className="relative overflow-hidden" data-id="element-1551">
        {/* Background with parallax effect */}
        <div className="absolute inset-0 z-0" data-id="element-1552">
          <div className="absolute inset-0 bg-gradient-to-b from-black/90 via-black/80 to-black/70 z-10" data-id="element-1553"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8EBZJkJmW22tzM2DKUohP4/IMG_3319-scaled-1.jpg" alt="BKCustoms werkplaats" className="w-full h-full object-cover object-center" data-id="element-1554" />
        </div>
        <div className="relative z-10 pt-40 pb-24 px-6 lg:px-8 max-w-screen-xl mx-auto" data-id="element-1555">
          <div className="max-w-3xl" data-id="element-1556">
            {/* Logo */}
            <div className="mb-8" data-id="element-1557">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/adgHjwdfFHAKcJTTi1A4e1/BK-Customs-Logo-DEF-01.png" alt="BKCustoms Logo" className="h-32 w-auto" data-id="element-1558" />
            </div>
            {/* Subtle badge */}
            <div className="inline-flex items-center bg-white/5 backdrop-blur-sm rounded-full py-1.5 px-3 mb-6" data-id="element-1559">
              <span className="text-white/80 text-xs font-medium tracking-wide" data-id="element-1560">
                SINDS 2020 • ALMERE
              </span>
            </div>
            <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight mb-6" data-id="element-1561">
              Het verhaal
              <br data-id="element-1562" />
              achter <span className="text-[#D6281F]" data-id="element-1563">BKCustoms</span>
            </h1>
            <p className="text-xl text-white/80 leading-relaxed mb-8 font-light" data-id="element-1564">
              Waar passie voor auto's en vakmanschap samenkomen
            </p>
          </div>
        </div>
        {/* Decorative element */}
        <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#0a0a0a] to-transparent z-10" data-id="element-1565"></div>
      </section>
      {/* Our Story Section - More Visual */}
      <section className="py-20 px-6 lg:px-8 max-w-screen-xl mx-auto" data-id="element-1566">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-1567">
          <div className="order-2 lg:order-1" data-id="element-1568">
            <h2 className="text-4xl font-bold text-white mb-8 leading-tight" data-id="element-1569">
              Gedreven door <span className="text-[#D6281F]" data-id="element-1570">passie</span>
            </h2>
            <div className="prose prose-lg prose-invert" data-id="element-1571">
              <p className="text-white/80 text-lg leading-relaxed mb-6" data-id="element-1572">
                BKCustoms is ontstaan uit pure liefde voor auto's. Met meer dan
                10 jaar ervaring in de branche, besloten we in 2020 onze eigen
                droom te verwezenlijken: een plek creëren waar auto's worden
                getransformeerd met precisie, creativiteit en toewijding.
              </p>
              <p className="text-white/80 text-lg leading-relaxed" data-id="element-1573">
                Bij ons draait alles om jouw wensen. We luisteren, adviseren en
                werken samen om jouw auto de unieke uitstraling te geven die
                perfect bij jou past.
              </p>
            </div>
            <Link to="/afspraak-maken" className="inline-flex items-center bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 mt-8 group border border-white/10" data-id="element-1574">
              <span className="mr-2" data-id="element-1575">Maak kennis met ons team</span>
              <ArrowRightIcon size={16} className="transition-transform duration-300 group-hover:translate-x-1" data-id="element-1576" />
            </Link>
          </div>
          {/* Visual element */}
          <div className="order-1 lg:order-2" data-id="element-1577">
            <div className="relative" data-id="element-1578">
              <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] via-[#FF6B00] to-[#FFD500] opacity-30 blur-lg rounded-lg" data-id="element-1579"></div>
              <div className="relative h-[500px] overflow-hidden rounded-lg border border-white/10 shadow-2xl" data-id="element-1580">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/epTaMYxL4anUJLdbRfE6sf/Afbeelding-van-WhatsApp-op-2024-09-11-om-03.56.27_c7bf755e.jpg" alt="Auto styling met passie" className="w-full h-full object-cover object-center" data-id="element-1581" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-1582"></div>
                {/* Quote overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-8" data-id="element-1583">
                  <blockquote className="italic text-white text-lg font-light" data-id="element-1584">
                    "Elke auto vertelt een verhaal. Wij helpen dat verhaal vorm
                    te geven."
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Values Section - More Creative */}
      <section className="py-20 bg-[#0f0f0f] relative overflow-hidden" data-id="element-1585">
        {/* Subtle pattern overlay */}
        <div className="absolute inset-0 z-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre-v2.png')]" data-id="element-1586"></div>
        <div className="relative z-10 px-6 lg:px-8 max-w-screen-xl mx-auto" data-id="element-1587">
          <div className="text-center mb-16" data-id="element-1588">
            <h2 className="text-4xl font-bold text-white mb-6" data-id="element-1589">
              Waar wij voor <span className="text-[#D6281F]" data-id="element-1590">staan</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1591">
            {[{
            icon: <HeartIcon className="text-[#D6281F]" data-id="element-1592" />,
            title: 'Passie',
            description: 'Elke auto die onze werkplaats binnenkomt, behandelen we met dezelfde toewijding als onze eigen voertuigen.'
          }, {
            icon: <StarIcon className="text-[#D6281F]" data-id="element-1593" />,
            title: 'Kwaliteit',
            description: 'We werken uitsluitend met premium materialen en technieken voor een resultaat waar je trots op kunt zijn.'
          }, {
            icon: <UsersIcon className="text-[#D6281F]" data-id="element-1594" />,
            title: 'Persoonlijk',
            description: 'Jouw wensen staan centraal. We luisteren, adviseren en creëren samen jouw ideale auto.'
          }, {
            icon: <ZapIcon className="text-[#D6281F]" data-id="element-1595" />,
            title: 'Innovatie',
            description: 'We blijven continu op de hoogte van de nieuwste trends en technieken in car styling.'
          }].map((value, index) => <div key={index} className="bg-gradient-to-br from-[#0a0a0a] to-[#151515] p-8 rounded-lg border border-white/5 hover:border-white/10 transition-all duration-300 group" data-id="element-1596">
                <div className="bg-black/30 p-4 rounded-full inline-flex mb-6 group-hover:bg-[#D6281F]/20 transition-colors duration-300" data-id="element-1597">
                  {cloneElement(value.icon, {
                size: 28
              })}
                </div>
                <h3 className="text-xl font-bold text-white mb-4" data-id="element-1598">
                  {value.title}
                </h3>
                <p className="text-white/70" data-id="element-1599">{value.description}</p>
              </div>)}
          </div>
        </div>
      </section>
      {/* Customer Stories Section */}
      <section className="py-20 px-6 lg:px-8 max-w-screen-xl mx-auto" data-id="element-1600">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-1601">
          <div className="w-full lg:w-1/2" data-id="element-1602">
            <div className="relative" data-id="element-1603">
              <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] to-[#FF6B00] opacity-30 blur-lg rounded-lg" data-id="element-1604"></div>
              <div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl" data-id="element-1605">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3v8Pos7TXNGtqMbGvoXuvd/Afbeelding-van-WhatsApp-op-2024-09-12-om-10.45.41_fb59bef4.jpg" alt="Tevreden klant met Mercedes-AMG bij BKCustoms" className="w-full h-auto object-cover" data-id="element-1606" />
              </div>
            </div>
          </div>
          <div className="w-full lg:w-1/2" data-id="element-1607">
            <h2 className="text-4xl font-bold text-white mb-8 leading-tight" data-id="element-1608">
              Jij staat <span className="text-[#D6281F]" data-id="element-1609">centraal</span>
            </h2>
            <div className="prose prose-lg prose-invert" data-id="element-1610">
              <p className="text-white/80 text-lg leading-relaxed mb-6" data-id="element-1611">
                Bij BKCustoms draait alles om jou en jouw auto. We nemen de tijd
                om te luisteren naar jouw wensen en ideeën, en vertalen deze
                naar een eindresultaat dat jouw verwachtingen overtreft.
              </p>
              <p className="text-white/80 text-lg leading-relaxed" data-id="element-1612">
                Of je nu op zoek bent naar subtiele verfijning of een complete
                transformatie, ons team staat klaar om jouw auto de aandacht te
                geven die het verdient.
              </p>
            </div>
            <div className="mt-10 flex flex-col sm:flex-row gap-4" data-id="element-1613">
              <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-1614">
                <span className="mr-2" data-id="element-1615">Maak een afspraak</span>
                <ArrowRightIcon size={16} data-id="element-1616" />
              </Link>
              <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-1617">
                Neem contact op
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Location Section */}
      <section className="py-20 bg-[#0f0f0f] relative overflow-hidden" data-id="element-1618">
        <div className="relative z-10 px-6 lg:px-8 max-w-screen-xl mx-auto" data-id="element-1619">
          <div className="text-center mb-12" data-id="element-1620">
            <h2 className="text-4xl font-bold text-white mb-6" data-id="element-1621">
              Bezoek onze <span className="text-[#D6281F]" data-id="element-1622">werkplaats</span> in
              Almere
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto" data-id="element-1623">
              Kom langs voor een persoonlijk advies of om je auto te laten
              transformeren door ons team van specialisten.
            </p>
          </div>
          <div className="bg-[#0a0a0a] rounded-lg overflow-hidden border border-white/10" data-id="element-1624">
            <div className="aspect-w-16 aspect-h-9 h-[400px]" data-id="element-1625">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8EBZJkJmW22tzM2DKUohP4/IMG_3319-scaled-1.jpg" alt="BKCustoms werkplaats in Almere" className="w-full h-full object-cover" data-id="element-1626" />
            </div>
            <div className="p-8 flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-1627">
              <div data-id="element-1628">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-1629">
                  BKCustoms Almere
                </h3>
                <p className="text-white/70" data-id="element-1630">
                  Microfoonstraat 36, 1322 BN Almere
                </p>
                <p className="text-white/70 mt-2" data-id="element-1631">
                  Ma-Za: 08:00-19:30 | Zo: Op afspraak
                </p>
              </div>
              <Link to="/contact" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center whitespace-nowrap" data-id="element-1632">
                <span className="mr-2" data-id="element-1633">Route plannen</span>
                <ArrowRightIcon size={16} data-id="element-1634" />
              </Link>
            </div>
          </div>
          {/* Logo in footer */}
          <div className="mt-16 text-center" data-id="element-1635">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/adgHjwdfFHAKcJTTi1A4e1/BK-Customs-Logo-DEF-01.png" alt="BKCustoms Logo" className="h-24 w-auto mx-auto" data-id="element-1636" />
          </div>
        </div>
      </section>
    </main>;
};